import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;
const BASENAME = import.meta.env.BASE_URL;
const API_DESPACHO_WEB = import.meta.env.VITE_API_DESPACHO_WEB.replace(/^\//, "");

const NotificationsService = {
    corporationImage: API_URL + "/corporation/entity/image",
    
    attachError: API_URL + "/public/assets/img/sentry.imgnotfound.large.748x480.png",

    gisIcon: API_URL + "/public/assets/img/custom_icons/gis-icon.svg",
    
    attachUrl: (attachId) => attachId ? API_KEEPER + `/ged/attach/${attachId}` : "",

    iconBase: (iconPath) => API_URL + `/public/assets/img/alarm_time_line${iconPath}`,

    gisUrl: ({ lat, lng, title }) => `${BASENAME}gis?latLng=${lat},${lng}&id=${title}`,

    occurrenceIcon: (hasOccurrence) => API_URL + "/public/assets/img/custom_icons/" + (hasOccurrence ? "sentry.occurrence.white.svg" : "sentry.occurrence.svg"),

    attendanceCreateUrl: (notificationId) => `${BASENAME}${API_DESPACHO_WEB}/attendance/form?notificationId=${notificationId}`,

    attendanceEditUrl: (attendanceId) => `${BASENAME}${API_DESPACHO_WEB}/attendance/form/${attendanceId}`,

    signedList: async (payload) => axios.post(API_KEEPER + "/notifications/list", payload).then(({ data }) => data).catch((err) => { throw err }),

    markAsSigned: async (formData) => axios.post(API_KEEPER + "/notifications/sign", formData).then(({ data }) => data).catch((err) => { throw err }),

    getConfig: async () => axios.get( API_URL + "/notifications/open/config").then(({ data }) => data).catch((err) => { throw err }),
    
    subscribe: ({ onMessage, onError } = {}) => {
        const eventSource = new EventSource(API_KEEPER + "/notifications/subscribe");
        if (onMessage) eventSource.onmessage = onMessage;
        if (onError) eventSource.onerror = onError;
        return eventSource;
    },

    openAnalise: () => axios.get(API_URL + "/notifications/openAnalise").catch((err) => { throw err })
};

export default NotificationsService;